export default __webpack_public_path__ + "static/media/mother-theresa.01d7dcdb.png";